import { Button, Popover, PopoverTrigger, Stack, Text } from '@ekhodealer/ekho-common/rev';

import ChevronDown12 from '@common/components/icons/ChevronDown12';
import { TextCell } from '@common/components/TextCell';

import { BuyerDetailsContent } from '../order-details/BuyerDetailsSection';

interface BuyerCellProps {
	buyerName: string;
	purchasedVehicleId: string;
}

const PopoverContent = ({ purchasedVehicleId }: { purchasedVehicleId: string }) => {
	return (
		<div style={{ minWidth: 360 }}>
			<Stack itemsSpacing='8'>
				<Text size='footnote' weight='semibold'>
					Details
				</Text>
				<Stack padding={{ right: '8' }}>
					<BuyerDetailsContent
						purchasedVehicleId={purchasedVehicleId}
						showAllFields={false}
					/>
				</Stack>
			</Stack>
		</div>
	);
};

export const BuyerCell = ({ buyerName, purchasedVehicleId }: BuyerCellProps) => {
	return (
		<PopoverTrigger>
			<Button
				className='buyer-cell'
				variant='ghost'
				size='xlarge'
				rounding='0'
				icon={<ChevronDown12 />}
				iconSide='right'>
				<TextCell value={buyerName} />
			</Button>
			<Popover offset={-12} crossOffset={-4}>
				<PopoverContent purchasedVehicleId={purchasedVehicleId} />
			</Popover>
		</PopoverTrigger>
	);
};
